import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';

import { createAppQueryClient } from './query-client';
import { createAppRouter } from './router';
import './styles/app.css';

const queryClient = createAppQueryClient();
const router = createAppRouter(queryClient);

const kontener = document.getElementById('root');
if (kontener === null) {
  throw new Error('Brak elementu montowania aplikacji');
}

createRoot(kontener).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
